import { useState } from "react";
import styles from "./ArrowAccordion.module.css";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import { useRef } from "react";
import { useEffect } from "react";

function ArrowAccordion({ data }) {
    const [activeRow, setActiveRow] = useState(0);
    const [ref, , fadedClassName] = useIntersectionObserver(0.2);

    return (
        <div
            className={[styles.arrow_accordion, fadedClassName].join(" ")}
            ref={ref}
        >
            {data.map((obj, index) => (
                <ArrowAccordionRow
                    activeRow={activeRow}
                    setActiveRow={setActiveRow}
                    obj={obj}
                    index={index}
                />
            ))}
        </div>
    );
}

export default ArrowAccordion;

function ArrowAccordionRow({ index, activeRow, setActiveRow, obj }) {
    const rowRef = useRef(null);
    const answerRef = useRef(null);

    useEffect(() => {
        rowRef.current.style.setProperty(
            "--answer-height",
            `${answerRef.current.offsetHeight + 20}px`
        );
    }, [answerRef, rowRef]);
    return (
        <div
            key={index}
            className={[
                styles.row,
                index === activeRow ? styles.active : "",
            ].join(" ")}
            onClick={() => setActiveRow(index)}
            ref={rowRef}
        >
            <div className={styles.index}>
                {(index + 1).toString().padStart(2, "0")}
            </div>
            <div className={styles.middle}>
                <div className={styles.question}>{obj.q}</div>
                <div className={styles.answer_overflow_container}>
                    <div
                        ref={answerRef}
                        className={styles.answer}
                        dangerouslySetInnerHTML={{ __html: obj.a }}
                    ></div>
                </div>
            </div>
            <button className={styles.right}>
                <svg
                    className={styles.arrow_svg}
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.00008 1.16666L7.00008 12.8333M7.00008 12.8333L1.16675 6.99999M7.00008 12.8333L12.8334 6.99999"
                        // stroke="#002C61"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
        </div>
    );
}
